/**
 * @typedef {import('../../../../App/shared/SubscriptionService/Subscription').default} Subscription
 * @typedef {import('./Response').default} Response
 */

import { subscriptionService } from '../../../../service-container';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @returns {Response}
 */
export default function useGetAgentSubscription() {
	const [subscription, setSubscription] = useState(
		/** @type {Subscription | null} */ (null)
	);
	const [isGettingData, setIsGettingData] = useState(true);

	useEffect(() => {
		getCheckoutLinks();
	}, []);

	async function getCheckoutLinks() {
		try {
			const response = await subscriptionService.getAgentSubscription();

			setSubscription(response);
		} catch (error) {
			captureError(error);
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: subscription,
			isGettingData,
		}),
		[isGettingData, subscription]
	);
}
